<template>
  <div class="row justify-content-center auditions-main">
    <div class="col-xl-4 col-md-6 col-11 login" v-show="dialogFlag">
      <p class="login-close" @click="setHideDialog"><span>×</span></p>
      <p class="tit">
        免费领取价值<span>300元</span>试听课
      </p>
      <input type="text" v-model="auditions.name" placeholder="请输入孩子的姓名">
      <select v-model="auditions.age" name="ages">
        <option value="">请选择孩子的年龄</option>
        <option :value="item" v-for="item in 20" :key="item">{{item}}</option>
      </select>
      <input type="text" v-model="mobile" placeholder="请输入手机号">
      <div class="code">
        <input type="text" v-model="auditions.captcha" placeholder="请输入验证码">
        <div class="btn" @click="!timeFlag && getSmscode()">
          <span v-show="!timeFlag">{{btnText}}</span>
          <span v-show="timeFlag">{{btnText}}s</span>
        </div>
      </div>
      <div class="submit" @click="receiveFlag && receive()">免费领取</div>
    </div>
    <div class="col-xl-4 col-md-6 col-11 dialog-succ" v-show="!dialogFlag">
      <div class="dialog-succ-img">
        <img src="https://static.cleanlive.cn/site/img/login-succ.png" alt="">
      </div>
      <p class="dialog-succ-text">预约成功</p>
      <p>课程顾问会尽快联系您约课，请保持手机畅通。</p>
      <div class="dialog-succ-btn" @click="setHideDialog">
        我知道了
      </div>
    </div>
    <div class="alert alert-warning" role="alert" v-show="alertShow">
      <strong>{{alertText}}</strong>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import qs from 'qs';

export default {
  name: 'auditions',
  props: ['mobile', 'step'],
  data() {
    return {
      alertText: '',
      receiveFlag: true,
      dialogFlag: true,
      timeFlag: false,
      alertShow: false,
      btnText: '获取验证码',
      auditions: {
        name: '',
        age: '',
        mobile: '',
        captcha: '',
        source: 1,
      },
    };
  },
  mounted() {
    if (this.step) {
      this.dialogFlag = false;
    }
  },
  methods: {
    getSmscode() {
      const params = {
        mobile: this.mobile,
        type: 4,
      };
      axios.post(`${process.env.API_HOST}/api/applystudys/smscode`, qs.stringify(params)).then((res) => {
        if (res.data.code === 200) {
          this.alertText = '验证码发送成功,请注意查收';
          this.timeFlag = true;
          this.btnText = 60;
          this.timer = setInterval(() => {
            if (this.btnText === 0) {
              clearInterval(this.timer);
              this.timeFlag = false;
              this.btnText = '获取验证码';
              return;
            }
            this.btnText -= 1;
          }, 1000);
        } else {
          this.alertText = res.data.tip;
        }
        this.alertShow = true;
        setTimeout(() => {
          this.alertShow = false;
          this.alertText = '';
        }, 2000);
      }).catch((err) => {
        console.lgo(err);
      });
    },
    receive() {
      this.auditions.mobile = this.mobile;
      if (this.auditions.name === '' || this.auditions.age === '' || this.auditions.mobile === '' || this.auditions.captcha === '') {
        this.alertText = '请填写相关信息';
        this.alertShow = true;
        setTimeout(() => {
          this.alertShow = false;
        }, 2000);
        return;
      }
      axios.post(`${process.env.API_HOST}/api/applystudys/create`, qs.stringify(this.auditions)).then((res) => {
        this.receiveFlag = false;
        setTimeout(() => {
          this.receiveFlag = true;
        }, 3000);
        if (res.data.code === 200) {
          this.dialogFlag = false;
          clearInterval(this.timer);
          this.timeFlag = false;
          this.btnText = '获取验证码';
          this.auditions = {
            name: '',
            age: '',
            mobile: '',
            captcha: '',
            source: 1,
          };
        } else {
          this.alertText = res.data.tip;
          this.alertShow = true;
          setTimeout(() => {
            this.alertShow = false;
          }, 2000);
        }
      }).catch((err) => {
        console.lgo(err);
      });
    },
    setHideDialog() {
      this.dialogFlag = true;
      this.$emit('setDiaLog');
    },
  },
};
</script>
<style lang="less" scoped>
@import '../assets/css/reset.less';
.auditions-main {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10;
  .login {
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 66;
    max-height: 600px;
    background: #ffffff;
    border-radius: 8px;
    .login-close {
      color: #ccc;
      font-size: 20px;
      font-weight: bold;
      text-align: right;
      padding: 2rem 2rem;
      box-sizing: border-box;
      span {
        cursor: pointer;
      }
    }
    .tit {
      font-size: 28px;
      margin: 0 0 5%;
      span {
        color: #fe9d15;
      }
    }
    input,
    select {
      padding: 13px 15px;
      width: 85%;
      height: 48px;
      outline: none;
      margin: 15px 0 0;
      border: 1px solid #c3c3c3;
      border-radius: 8px;
    }
    .code {
      display: flex;
      width: 85%;
      margin: 15px auto 0;
      justify-content: space-between;
      input {
        width: 60%;
        height: 48px;
        margin: 0;
      }
      .btn {
        width: 35%;
        height: 48px;
        border: none;
        line-height: 48px;
        padding: 0;
        color: #fff;
        background: linear-gradient(90deg, #ffb83f, #fe9000);
      }
    }
    .submit {
      width: 85%;
      height: 48px;
      border: none;
      line-height: 48px;
      padding: 0;
      color: #fff;
      cursor: pointer;
      border-radius: 8px;
      margin: 50px auto 0;
      background: linear-gradient(90deg, #ffb83f, #fe9000);
    }
  }
  .dialog-succ {
    max-width: 470px;
    max-height: 500px;
    text-align: center;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 66;
    background: #ffffff;
    border-radius: 8px;
    padding: 0 2rem;
    box-sizing: border-box;
    .dialog-succ-img {
      width: 207px;
      margin: 0 auto;
      padding: 4rem 2rem 1rem;
      box-sizing: border-box;
    }
    .dialog-succ-text {
      font-size: 28px;
      font-family: PingFang-SC-Medium;
      color:rgba(254,157,21,1);
      line-height: 40px;
    }
    p {
      margin: 2rem 0;
      font-size: 16px;
      font-family: PingFang-SC-Medium;
      color:rgba(91,91,91,1);
    }
    .dialog-succ-btn {
      width: 74%;
      height: 48px;
      line-height: 46px;
      margin: 3rem auto;
      background: linear-gradient(90deg,rgba(255,184,63,1),rgba(254,144,0,1));
      border-radius: 8px;
      font-size: 18px;
      font-family: PingFang-SC-Medium;
      color:rgba(255,255,255,1);
      cursor: pointer;
    }
  }
  @media screen and (min-wdith: 1919px) {
    .login {
      width: 430px;
    }
  }
  @media screen and (max-width: 414px) {
    .dialog-succ {
      width: 90%;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/auditions.vue